var _rect, _rect2, _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 88,
    viewBox: "0 0 1280 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 88,
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_69",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1280,
    height: 88
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 88,
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_69)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_52_69",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1368,
    height: 401
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436.5 116H436.5C223 116 112 0 112 0H1368V400C1285.5 400 1142.64 379.109 1086 291C973.5 116 650 116 436.5 116Z",
    fill: "url(#paint0_linear_52_69)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1368 400V281.5C891 -29.5 787.86 39.5 710.947 161.12C608.168 323.642 121.075 371.641 0 361.453V400H1368Z",
    fill: "url(#paint1_linear_52_69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1368 243.5V400H0V94.2122C92.2698 69.7118 197.695 47.8393 374.5 94.2122C410.225 103.582 476.524 125.322 509.92 134.9C686.398 185.513 704.5 243.5 1368 243.5Z",
    fill: "url(#paint2_linear_52_69)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.86 400H1368C1354.37 393.387 1333.1 385.996 1251.86 384.229C589.401 369.821 415.227 255.63 238.5 125.89C210.875 105.61 183.217 85.3054 153.666 65.4653C97.6549 27.86 46.3166 7.67634 0 0V400H1251.86Z",
    fill: "url(#paint3_linear_52_69)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_52_69)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -172,
    y: -98,
    width: 1671,
    height: 601,
    fill: "#3D3D3D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_69",
    x1: 602,
    y1: -960.5,
    x2: 1093.5,
    y2: 272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_69",
    x1: 482,
    y1: 1058.5,
    x2: 480,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_69",
    x1: 424,
    y1: -587.5,
    x2: 446.108,
    y2: 274.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_69",
    x1: 587,
    y1: -1120.5,
    x2: 349.03,
    y2: 341.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.3023dcf1c23c7812f3560afc16a368a0.svg";
export { ForwardRef as ReactComponent };